module.exports = __webpack_public_path__ + "static/media/hamburgerIcon.d0ec09c1.svg";